// import {Search} from '@dabafinance/react-components';
import styles from './adminMainLayout.module.scss';
import {Dropdown, Menu, Form, Button} from 'antd';
import {CloseOutlined, DownOutlined} from '@ant-design/icons';
// import Avatar from 'components/avatar/avatar';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import DBModal from 'components/modal/modal';
import {useState} from 'react';
import {UpdateAdminProfile} from './UpdateAdminProfile';
import {RegenerateAWSURL} from 'components/RegenerateAWSURL/RegenerateAWSURL';
import DashboardSearch from 'components/dashboardSearch/DashboardSearch';
import DashboardHistory from 'components/dashboardHistory/DashboardHistory';
import FloatingHistoryButton from 'components/dashboardHistory/FloatingHistoryButton';
import AwaitingReplyFab from 'pages/aiHelpDesk/components/AwaitingReplyFab';
import {AdminPushToggle} from 'pages/aiHelpDesk/AdminPushToggle';
import {useHasSupportAccess} from 'hooks';
// import gamerIcon from 'images/man.png';
import {motion, AnimatePresence} from 'framer-motion';

const AdminMainLayout = ({children}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [form] = Form.useForm();
  const [updateUpdateModal, setUpdateUpdateModal] = useState({
    open: false,
    type: null,
    data: null,
  });
  const [isRegenerateURLModalOpen, setIsRegenerateURLModalOpen] =
    useState(false);

  const data = useSelector(state => state?.auth?.userData?.user);
  const navigate = useNavigate();
  const hasSupportAccess = useHasSupportAccess();
  const userRole = data?.activeAdminTab?.name;
  const canRegenerateURL = [
    'SUPERADMIN',
    'ADMIN',
    'FINANCIAL_OPERATOR',
  ].includes(userRole);
  const dropdownMenu = (
    <Menu>
      <Menu.Item onClick={() => navigate('/register')} key="0">
        <span>Create Admin Account</span>
      </Menu.Item>
      <Menu.Item onClick={() => navigate('/dashboard/admin-settings')} key="1">
        <span>Admin Settings</span>
      </Menu.Item>
      <Menu.Item
        onClick={() => navigate('/dashboard/referral-partners')}
        key="2">
        <span>Referral Partners</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <div className={styles.wrapper}>
      <nav className={styles.nav}>
        {userRole === 'SUPERADMIN' ? (
          <div className={styles.searchCluster}>
            <DashboardSearch />
            <DashboardHistory />
          </div>
        ) : (
          <h2>Daba Finance Administrative Dashboard</h2>
        )}
        <div className={styles.navActions}>
          {canRegenerateURL && (
            <Button
              onClick={() => setIsRegenerateURLModalOpen(true)}
              className={styles.regenerateButton}>
              Regenerate Expired URL
            </Button>
          )}
          {data?.activeAdminTab?.name === 'SUPERADMIN' ? (
            <Dropdown trigger="click" overlay={dropdownMenu}>
              <div className={styles.dropdownNav}>
                SUPER ADMIN
                <DownOutlined />
              </div>
            </Dropdown>
          ) : (
            <div className={styles.dropdownContainer}>
              {data?.firstName ? (
                <div>
                  <div
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className={styles.dummyAvatar}>
                    {data?.firstName?.charAt(0)}
                    {data?.lastName?.charAt(0)}
                  </div>
                </div>
              ) : (
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: 0,
                        label: 'Update Profile',
                        onClick: () =>
                          setUpdateUpdateModal({
                            open: true,
                            type: 'UPDATE_PROFILE',
                            data: data,
                          }),
                      },
                      {
                        key: 1,
                        label: 'Reset Password',
                        disabled: true,
                      },
                    ],
                  }}
                  trigger="click">
                  <div className={styles.dropdownNav}>
                    {data?.activeAdminTab?.name?.split('_')?.join(' ') ||
                      'ADMIN'}
                    <DownOutlined />
                  </div>
                </Dropdown>
              )}
              <AnimatePresence>
                {isDropdownOpen && (
                  <motion.div
                    className={styles.dropdownMenu}
                    initial={{opacity: 0, y: -20}}
                    animate={{opacity: 1, y: 0}}
                    exit={{opacity: 0, y: -20}}
                    transition={{duration: 0.3, ease: 'easeOut'}}>
                    <AdminProfile
                      data={data}
                      onClose={() => setIsDropdownOpen(false)}
                      onUpdateProfile={() =>
                        setUpdateUpdateModal({
                          open: true,
                          type: 'UPDATE_PROFILE',
                          data: data,
                        })
                      }
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          )}
        </div>
        {hasSupportAccess && (
          <AdminPushToggle className={styles.navBottomRow} />
        )}
      </nav>
      {children}
      <DBModal
        isOpen={updateUpdateModal.open}
        handleClose={() => {
          setUpdateUpdateModal({open: false, type: null, data: null});
        }}
        content={
          <UpdateAdminProfile
            form={form}
            onClose={() =>
              setUpdateUpdateModal({open: false, type: null, data: null})
            }
          />
        }
      />
      <RegenerateAWSURL
        isOpen={isRegenerateURLModalOpen}
        onClose={() => setIsRegenerateURLModalOpen(false)}
      />
      <FloatingHistoryButton />
      <AwaitingReplyFab />
    </div>
  );
};

export const AdminProfile = ({data, onClose, onUpdateProfile}) => {
  return (
    <div className={styles.adminProfile}>
      <div className={styles.closeModal} onClick={onClose}>
        <CloseOutlined />
      </div>
      <div className={styles.bigAvatar}>
        {data?.firstName?.charAt(0)}
        {data?.lastName?.charAt(0)}
      </div>
      <p className={styles.adminProfileName}>
        {data?.firstName} {data?.lastName}
      </p>
      <p className={styles.adminProfileEmail}>{data?.email}</p>
      <p className={styles.adminProfileRole}>
        {data?.activeAdminTab?.name?.split('_')?.join(' ')?.toLowerCase()}
      </p>
      <div className={styles.adminProfileActions}>
        <Button onClick={onUpdateProfile}>Update Profile</Button>
        <Button disabled>Reset Password</Button>
      </div>
    </div>
  );
};

export {AdminMainLayout};
